var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { title: "导入商品", visible: _vm.visible, width: "400px" },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        [
          _c("p", { staticClass: "hige-tips" }, [
            _vm._v(_vm._s(_vm.$t("stores::products-info::importTips"))),
          ]),
          _c(
            "p",
            { staticClass: "tips" },
            [
              _vm._v(
                " 1、" +
                  _vm._s(_vm.$t("stores::products-info::pleaseFirst")) +
                  " "
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "text", disabled: _vm.exportLoading },
                  on: { click: _vm.exportGoods },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("stores::products-info::exportGoods")) +
                      " "
                  ),
                ]
              ),
              _vm._v(
                " " + _vm._s(_vm.$t("stores::products-info::editing")) + " "
              ),
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.exportLoading,
                    expression: "exportLoading",
                  },
                ],
                staticClass: "el-icon-loading",
              }),
            ],
            1
          ),
          _c("p", { staticClass: "tips mb-40" }, [
            _vm._v("2、" + _vm._s(_vm.$t("stores::products-info::importFile"))),
          ]),
          _c(
            "el-upload",
            {
              ref: "upload",
              attrs: {
                action: "",
                drag: "",
                "auto-upload": false,
                "show-file-list": false,
                "on-change": _vm.onchangeUpload,
              },
            },
            [
              _vm.fileUrl
                ? _c("div", { staticClass: "upload_wrap" }, [
                    _c("div", { staticClass: "list-wrap" }, [
                      _c("p", [_vm._v(_vm._s(_vm.fileUrl.name))]),
                    ]),
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "upload_wrap" },
                [
                  _c("i", { staticClass: "el-icon-plus" }),
                  _c("el-button", { staticClass: "add-file-btn" }, [
                    _vm._v(_vm._s(_vm.$t("system::tip::upload_click"))),
                  ]),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("system::tip::upload_drag_tip"))),
                  ]),
                ],
                1
              ),
              _c("div", { attrs: { slot: "tip" }, slot: "tip" }, [
                _vm._v(_vm._s(_vm.$t("stores::products-info::importDesc"))),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("system::common::btn::cancel")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.submit },
            },
            [_vm._v(_vm._s(_vm.$t("system::common::btn::confirm")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }